/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface ConditionalArgs {
  /** Condition params */
  boolParam: boolean;
  intParam: number;
  floatParam: number;
  strParam: string;
}

export interface ConditionalActionArgs {
  /** Condition params */
  conditionArgs:
    | ConditionalArgs
    | undefined;
  /** If true, completes only when condition is satisfied, else keeps running */
  asynchronous: boolean;
}

export interface SubjectDetectedResultData {
}

export interface SubjectDetectedActionStateData {
}

function createBaseConditionalArgs(): ConditionalArgs {
  return { boolParam: false, intParam: 0, floatParam: 0, strParam: "" };
}

export const ConditionalArgs = {
  encode(message: ConditionalArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.boolParam === true) {
      writer.uint32(8).bool(message.boolParam);
    }
    if (message.intParam !== 0) {
      writer.uint32(16).int64(message.intParam);
    }
    if (message.floatParam !== 0) {
      writer.uint32(29).float(message.floatParam);
    }
    if (message.strParam !== "") {
      writer.uint32(34).string(message.strParam);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConditionalArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConditionalArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.boolParam = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.intParam = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.floatParam = reader.float();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.strParam = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConditionalArgs {
    return {
      boolParam: isSet(object.boolParam) ? globalThis.Boolean(object.boolParam) : false,
      intParam: isSet(object.intParam) ? globalThis.Number(object.intParam) : 0,
      floatParam: isSet(object.floatParam) ? globalThis.Number(object.floatParam) : 0,
      strParam: isSet(object.strParam) ? globalThis.String(object.strParam) : "",
    };
  },

  toJSON(message: ConditionalArgs): unknown {
    const obj: any = {};
    if (message.boolParam === true) {
      obj.boolParam = message.boolParam;
    }
    if (message.intParam !== 0) {
      obj.intParam = Math.round(message.intParam);
    }
    if (message.floatParam !== 0) {
      obj.floatParam = message.floatParam;
    }
    if (message.strParam !== "") {
      obj.strParam = message.strParam;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionalArgs>, I>>(base?: I): ConditionalArgs {
    return ConditionalArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionalArgs>, I>>(object: I): ConditionalArgs {
    const message = createBaseConditionalArgs();
    message.boolParam = object.boolParam ?? false;
    message.intParam = object.intParam ?? 0;
    message.floatParam = object.floatParam ?? 0;
    message.strParam = object.strParam ?? "";
    return message;
  },
};

function createBaseConditionalActionArgs(): ConditionalActionArgs {
  return { conditionArgs: undefined, asynchronous: false };
}

export const ConditionalActionArgs = {
  encode(message: ConditionalActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.conditionArgs !== undefined) {
      ConditionalArgs.encode(message.conditionArgs, writer.uint32(10).fork()).ldelim();
    }
    if (message.asynchronous === true) {
      writer.uint32(16).bool(message.asynchronous);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConditionalActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConditionalActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conditionArgs = ConditionalArgs.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.asynchronous = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConditionalActionArgs {
    return {
      conditionArgs: isSet(object.conditionArgs) ? ConditionalArgs.fromJSON(object.conditionArgs) : undefined,
      asynchronous: isSet(object.asynchronous) ? globalThis.Boolean(object.asynchronous) : false,
    };
  },

  toJSON(message: ConditionalActionArgs): unknown {
    const obj: any = {};
    if (message.conditionArgs !== undefined) {
      obj.conditionArgs = ConditionalArgs.toJSON(message.conditionArgs);
    }
    if (message.asynchronous === true) {
      obj.asynchronous = message.asynchronous;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionalActionArgs>, I>>(base?: I): ConditionalActionArgs {
    return ConditionalActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionalActionArgs>, I>>(object: I): ConditionalActionArgs {
    const message = createBaseConditionalActionArgs();
    message.conditionArgs = (object.conditionArgs !== undefined && object.conditionArgs !== null)
      ? ConditionalArgs.fromPartial(object.conditionArgs)
      : undefined;
    message.asynchronous = object.asynchronous ?? false;
    return message;
  },
};

function createBaseSubjectDetectedResultData(): SubjectDetectedResultData {
  return {};
}

export const SubjectDetectedResultData = {
  encode(_: SubjectDetectedResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubjectDetectedResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubjectDetectedResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SubjectDetectedResultData {
    return {};
  },

  toJSON(_: SubjectDetectedResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SubjectDetectedResultData>, I>>(base?: I): SubjectDetectedResultData {
    return SubjectDetectedResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubjectDetectedResultData>, I>>(_: I): SubjectDetectedResultData {
    const message = createBaseSubjectDetectedResultData();
    return message;
  },
};

function createBaseSubjectDetectedActionStateData(): SubjectDetectedActionStateData {
  return {};
}

export const SubjectDetectedActionStateData = {
  encode(_: SubjectDetectedActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubjectDetectedActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubjectDetectedActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SubjectDetectedActionStateData {
    return {};
  },

  toJSON(_: SubjectDetectedActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SubjectDetectedActionStateData>, I>>(base?: I): SubjectDetectedActionStateData {
    return SubjectDetectedActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubjectDetectedActionStateData>, I>>(_: I): SubjectDetectedActionStateData {
    const message = createBaseSubjectDetectedActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
